@if (message()) {
  <output class="red-claim">
    <mat-icon class="red-claim__icon" aria-hidden="true">schedule</mat-icon>
    <span class="red-claim__text">{{ message() }}</span>
    <button type="button" class="red-claim__release" (click)="release()">Release</button>
  </output>
}
